import { isStaging } from '../config';
import { authHeaderStage, authHeaderProd } from './constants';
import React from 'react'
import moment from 'moment';


export const disableBodyScrolling = (condition) => {
  if (condition) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'visible';
  }
};

export const amountFormatting = amount => {
  if(!amount) return '0.0';
  return (amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

export const removeDataFromStorage = () => {
  const arr = ['operator-details', 'access-token', 'access-code', 'merchant-id', 'logged-in-data'];
  arr.forEach(el => localStorage.removeItem(el))
}

export const fetchMerchantId = () =>{
  const params = new URLSearchParams(window.location.search || '');
  const merchant = params.get('merchant');
  if(merchant){
    localStorage.setItem('merchant-id', merchant);
  }
  return merchant;
}


export const formSeatMap = (seatMap, provider_trip_id) => { 
  seatMap.body = seatMap.seats;
  let bus = {
    seats: [],
    seatsUpper: [],
    smStringLower: [],
    smStringUpper: [],
    lowerCollection: [],
    upperCollection: [],
    upperSeatsCount: 0,
    lowerSeatCount: 0,
    body: null,
    error: null
  };

  let selectedSeatsMap = {};
  let minColLower = Infinity, minColUpper = Infinity, maxColLower = -Infinity, maxColUpper = -Infinity;
  let lowerCollection = [], upperCollection = [];
  let eLengthLower, eLengthUpper, highestStrLengthLower = -Infinity, highestStrLengthUpper = -Infinity;
  let lowerRowdata = [], upperRowdata = [];
  let rowTransformLower = {}, rowTransformUpper = {};
  let smStringLower = [], smStringUpper = [];
  let iter, jter;


  if (provider_trip_id)
    seatMap.provider_trip_id = provider_trip_id;

  if (seatMap && seatMap.body && seatMap.body.length) {

    seatMap.body.forEach(v => {
      v.row = parseInt(v.row);
      v.column = parseInt(v.column);
      v.width = parseInt(v.width);
      v.length = parseInt(v.length);

      if (v.is_lower_berth) {
        if (v.column < minColLower)
          minColLower = v.column;

        lowerRowdata[v.row] = 1;

        if (v.column >= maxColLower) {
          maxColLower = v.column;
          eLengthLower = (v.length == 2) ? v.column + 2 : v.column + 1;
          if (eLengthLower > highestStrLengthLower)
            highestStrLengthLower = eLengthLower;
        }
      } else {
        if (v.column < minColUpper)
          minColUpper = v.column;

        upperRowdata[v.row] = 1;


        if (v.column >= maxColUpper) {
          maxColUpper = v.column;
          eLengthUpper = (v.length == 2) ? v.column + 2 : v.column + 1;
          if (eLengthUpper > highestStrLengthUpper)
            highestStrLengthUpper = eLengthUpper;
        }
      }
    });

    highestStrLengthLower = highestStrLengthLower - minColLower;
    highestStrLengthUpper = highestStrLengthUpper - minColUpper;
    let strLower = createEmptySpacesRow(highestStrLengthLower);
    let strUpper = (highestStrLengthUpper > 0) && createEmptySpacesRow(highestStrLengthUpper);


    //new trimming and seatmap 0 indexing code.
    jter = 0;
    for (iter = 0; iter < lowerRowdata.length; iter++) {
      if (lowerRowdata[iter] == 1) {
        rowTransformLower[iter] = jter;
        jter++;
      }
      if (!lowerRowdata[iter] && lowerRowdata[iter + 1] && jter !== 0)
        jter++
    }

    smStringLower = new Array(jter - 1);

    if (highestStrLengthUpper > 0) {
      jter = 0;
      for (iter = 0; iter < upperRowdata.length; iter++) {
        if (upperRowdata[iter] == 1) {
          rowTransformUpper[iter] = jter;
          jter++;
        }
        if (!upperRowdata[iter] && upperRowdata[iter + 1] && jter !== 0)
          jter++;
      }
      smStringUpper = new Array(jter - 1);
    }


    seatMap.body.forEach((v, i) => {
      v.index = i;
      selectedSeatsMap[i] = false;
      let detailedFare, baseFare, revisedBaseFare = undefined;

      detailedFare = v.detailed_fare;
      if (detailedFare) {
        baseFare = parseInt(detailedFare.base_fare);
        if (detailedFare.deal) {
          revisedBaseFare = parseInt(detailedFare.deal.revised_base_fare);
        }
      }
      else {
        baseFare = parseInt(v.fare);
      }
      v.baseFare = baseFare;
      v.revisedBaseFare = revisedBaseFare;
      let transformedRow, transformedColumn;
      if (v.is_lower_berth) {
        transformedRow = rowTransformLower[v.row];
        if (!(transformedRow in smStringLower)) {
          smStringLower[transformedRow] = strLower;
        }

        transformedColumn = v.column - minColLower;

        if (!(transformedRow in lowerCollection))
          lowerCollection[transformedRow] = [];

        lowerCollection[transformedRow][transformedColumn] = v;

        if (v.length === 1) {
          smStringLower[transformedRow] = replaceString(smStringLower[transformedRow], transformedColumn, 's');
        }
        else if (v.length === 2) {
          smStringLower[transformedRow] = replaceString(smStringLower[transformedRow], transformedColumn, 'SL');
        }
      }
      else if (!v.is_lower_berth) {
        transformedRow = rowTransformUpper[v.row];
        if (!(transformedRow in smStringUpper))
          smStringUpper[transformedRow] = strUpper

        transformedColumn = v.column - minColUpper;

        if (!(transformedRow in upperCollection))
          upperCollection[transformedRow] = [];

        upperCollection[transformedRow][transformedColumn] = v;

        if (v.length === 1) {
          smStringUpper[transformedRow] = replaceString(smStringUpper[transformedRow], transformedColumn, 's');
        }
        else if (v.length === 2) {
          smStringUpper[transformedRow] = replaceString(smStringUpper[transformedRow], transformedColumn, 'SL');
        }
      }
      //old seatmap code
      if (v.is_lower_berth) {
        bus.seats[v.row] = bus.seats[v.row] ? bus.seats[v.row] : [];
        bus.seats[v.row][v.column] = v ? { ...v } : false;
      }

      else if (!v.is_lower_berth) {
        bus.seatsUpper[v.row] = bus.seatsUpper[v.row] ? bus.seatsUpper[v.row] : [];
        bus.seatsUpper[v.row][v.column] = v ? { ...v } : false;
      }

    });


    //remove nulls from lowerCollection and upperCollection
    lowerCollection.forEach((v, i) => {
      if (v && Array.isArray(v))
        lowerCollection[i] = v.filter(v1 => !!v1);
    });

    //lowerCollection = lowerCollection.reverse();

    if (upperCollection && upperCollection.length) {
      upperCollection.forEach((v, i) => {
        if (v && Array.isArray(v))
          upperCollection[i] = v.filter(v1 => !!v1);
      });
      //upperCollection = upperCollection.reverse();
    }

    //smStringLower = smStringLower.reverse();
    bus.lowerCollection = lowerCollection;
    bus.smStringLower = smStringLower;

    if (smStringUpper.length) {
      bus.smStringUpper = smStringUpper;
      bus.upperCollection = upperCollection;
    }
    bus.body = seatMap.body;
    bus.provider_trip_id = seatMap.provider_trip_id;
    bus.meta = seatMap.meta;
  }

  // in case of error show the message
  if (seatMap && seatMap.error) {
    bus.error = seatMap.error;
  }
  return bus;
}
function replaceString(str, index, replacement) {
  return str.substr(0, index) + replacement + str.substr(index + replacement.length);
}

function createEmptySpacesRow(len) {
  let i, s = '';
  for (i = 0; i < len; i++)
    s += 'e';
  return s;
}

const triggerLoginScreenLoad = () => {
  const config = {
    theme: {
      header: {
        forgotPassword: 'Forgot Password',
      },
      text: {
        signInTab: 'Sign In to Paytm',
        signInBtnText: 'LOGIN',
        forgetPasswordText: 'Forgot Password',
        loginQROtpFallBackBtn: 'Scan QR Code and Login',
        qrInfo: '',
        tandcText: 'Terms & Conditions',
        privacyPolicyText: 'Privacy Policy.',
      },
      label: {
        signInEmailMobile: 'Registered Paytm Mobile Number or Email ID',
        signInPassword: 'Paytm Password',
      },
    },
    components:{
      login: {
        email: true,
        mobile: true,
        QR: false,
        description: '',
        signInNote: false
      },
      otp: false,
      signup: false,
    },
    redirectUri: isStaging ? 'https://travel-dev.paytm.com/v1/api/authresponse' : 'https://bus.paytm.com/v1/api/authresponse',
    redirectInFrame: true,
    scope: 'paytm',
    responseType: 'code',
    state: "null",
    clientId: isStaging ? 'busoperator-panel-stg' : 'busoperator-panel',
    authorization: `Basic ${isStaging ? authHeaderStage : authHeaderProd}`,
    cssRules: [
      ['.container', ['padding', '40px', true]],
      ['iframe', ['width', '400px', true], ['height', '444px', true]],
      ['.btnCont', ['display', 'flex', true], ['flex-direction', 'column-reverse', true], ['align-items', 'flex-end', true]],
      ['.fieldContainer', ['width', '100%', true]],
      ['div[oauth-id="signInTab"]', ['padding-bottom', '12px', true], ['display', 'inline-flex', true], ['font-size', '14px', true], ['font-weight', '600', true], ['color', '#2e2f30', true], ['font-family', `'Open Sans',Arial,sans-serif`, true], ['border-bottom', '2px solid #00D7FF', true]],
      ['button[oauth-id="login_button"]', ['width', '100%', true], ['display', 'inline-flex', true], ['justify-content', 'center', true]],
      ['input[oauth-id="input_email"]', ['border', 'none', true], ['border-bottom', '1px solid #e6ebf3', true]],
      ['input[oauth-id="input_email"]::placeholder', ['color', '#333435', true], ['font-weight', '100', true]],
      ['input[oauth-id="input_password"]', ['border', 'none', true], ['border-bottom', '1px solid #e6ebf3', true]],
      ['input[oauth-id="input_password"]::placeholder', ['color', '#333435', true], ['font-weight', '100', true]],
      ['.terms-cond', ['color', '#a3a3a3', true], ['font-size', '11px', true], ['line-height', '1.45', true]],
    ],
  };
  // eslint-disable-next-line no-undef
  Oauth.init(config);
};

export const openOauthSDKLogin = async () => {
  const loginWithOtpUi = '<iframe id="oauth-iframe" height="100%" width="100%"></iframe>';

  if (loginWithOtpUi) {
    const otpUIFragment = document.createRange().createContextualFragment(loginWithOtpUi);
    const iframeUI = otpUIFragment.firstElementChild;
    if (iframeUI && document.querySelector('.iframeHolder')) {
      iframeUI.onload = function () { triggerLoginScreenLoad(); };
      document.querySelector('.iframeHolder').appendChild(iframeUI);
    }
  }
};

export const hightLightText = (str, val) => {
  var index = str.toLowerCase().indexOf(val.toLowerCase());
  if (index > 0) {
    return [
      str.substring(0, index),
      <b key={1} style={{ color: "#000" }}>
        {val}
      </b>,
      str.substring(index + val.length),
    ];
  } else if (index === 0) {
    return [
      <b key={1} style={{ color: "#000" }}>
        {str.substring(0, index + val.length)}
      </b>,
      str.substring(index + val.length),
    ];
  }
  return str;
}

export const dateCalculation = (selectedDuration) => {
      const endDate = moment().format('YYYY-MM-DD HH:mm:ss');
      let startDate = '';
      if(selectedDuration === 'today') {
        startDate = moment(endDate).startOf('day').format('YYYY-MM-DD HH:mm:ss');
      } else if(selectedDuration === 'weekly') {
        startDate = moment(endDate).subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss');
      }else if(selectedDuration === '2days')  {
        startDate = moment(endDate).subtract(2, 'days').format('YYYY-MM-DD HH:mm:ss');
      }else if(selectedDuration === '30days')  {
        startDate = moment(endDate).subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss');
      }

      return {endDate, startDate};
}

export const dealSelected = (() => {
  return {
    set: (isDealSelected, dealValue, dealKey) => {
      sessionStorage.setItem('isDealSelected', JSON.stringify({ isDealSelected, dealValue, dealKey }));
    },
    get: () => {
      return JSON.parse(sessionStorage.getItem('isDealSelected')) || false;
    },
  };
})()